import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Zero Downtime",
    body: "A dead truck is money bleeding out on the shoulder. We answer around the clock and roll immediately — because every minute your rig sits, your livelihood sits with it.",
  },
  {
    n: "02",
    title: "Heavy Rig Recovery",
    body: "Semis, tractor-trailers, box trucks, RVs and campers — if it has axles, we can move it. Heavy winches, flatbeds, and the know-how to recover without adding damage.",
  },
  {
    n: "03",
    title: "Fair Roadside Rates",
    body: "You're already having a bad day. Our customers say it best: quick as possible, fair price, and real appreciation for your vehicle — whether it's a showpiece or a rust bucket.",
  },
];

export default function Manifesto() {
  return (
    <section id="ethos" data-testid="manifesto-section" className="relative bg-ink py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-ember"
          data-testid="manifesto-overline"
        >
          The Flatlander Code
        </motion.p>
        <div className="mt-12 space-y-2">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              data-testid={`manifesto-chapter-${c.n}`}
              className="group grid grid-cols-1 gap-6 border-t border-white/10 py-12 transition-colors duration-300 hover:border-ember/50 md:grid-cols-12 md:gap-10"
            >
              <div className="md:col-span-3">
                <span className="text-stroke font-display text-7xl font-black leading-none transition-colors duration-300 sm:text-8xl">
                  {c.n}
                </span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-display text-3xl font-extrabold uppercase tracking-tight text-white transition-colors duration-300 group-hover:text-ember sm:text-4xl">
                  {c.title}
                </h3>
              </div>
              <div className="md:col-span-5">
                <p className="text-base leading-relaxed text-slate-400">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
